import { FormBase } from 'core/components';

export default class PasswordRecoveryForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			showErrorsOnReset: true,
		});
	}

	setup() {
		return {
			fields: [
				{
					name: 'organizationIdentifier',
					label: 'PASSWORDRECOVERYFORM.ORGANIZATIONIDENTIFIER',
					rules: 'required|string',
				},
				{
					name: 'usernameOrEmail',
					label: 'PASSWORDRECOVERYFORM.USERNAMEOREMAIL',
					rules: 'required|string',
				},
				{
					name: 'sms',
				},
				{
					name: 'voiceCall',
				},
				{
					name: 'verificationCode',
					label: 'TWOSTEPAUTHENTICATION.VERIFICATIONCODE',
				},
			],
		};
	}
}
